import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { AttendeeDialogComponent } from '../attendee-dialog/attendee-dialog.component';

@Component({
  selector: 'app-predefined-notes-field',
  templateUrl: './predefined-notes-field.component.html',
  styleUrls: ['./predefined-notes-field.component.css']
})
export class PredefinedNotesFieldComponent implements OnInit {


  preDefinedNotes:any;
  agendaList:any;
  agendaPresenterList: any = [];

  notesValue : any

  predefinedNotesArray : any = []
  

  constructor(private matDialogRef: MatDialogRef<PredefinedNotesFieldComponent>,private meetingService: MeetingService,private globals: Globals,@Inject(MAT_DIALOG_DATA) data: any) { 


    this.agendaList = data.e;

    var reqJSON = {
      "meetingId": this.agendaList.meetingId,
      "agendaId": this.agendaList.agendaId
    };
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
 
      this.agendaList = data.body;
      if(data.body.defaultNotes != "" && data.body.defaultNotes != null && data.body.defaultNotes != undefined){
        this.notesEditBox.controls['defaultNotes'].setValue(data.body.defaultNotes);
      }
    });
    //
    //
    this.setData();
  }

  addPredefinedNotes(){
    this.predefinedNotesArray.unshift(this.notesValue)
    this.notesEditBox = new UntypedFormGroup({
      agendaTitle: new UntypedFormControl(''),
      agendaId: new UntypedFormControl(''),
      agendaDuration: new UntypedFormControl(''),
      agendaPresenterList: new UntypedFormControl(''),
      // defaultNotes: new FormControl(''),
      userId: new UntypedFormControl(''),
      meetingId:new UntypedFormControl(''),
    });
  }

  deleteListItem(index: any){
    this.predefinedNotesArray.splice(index, 1)
  }

  trackPredefinedNotes(e : any){
    this.notesValue = e.target.value
  }

  ngOnInit(): void {
  }

  notesEditBox = new UntypedFormGroup({
    agendaTitle: new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    agendaDuration: new UntypedFormControl(''),
    agendaPresenterList: new UntypedFormControl(''),
    defaultNotes: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    meetingId:new UntypedFormControl(''),
  });

  setData(){
    this.agendaList.agendaPresenterList.forEach((presenter: any) => {
      var presenterJsonList={
        "presenterUserId" : presenter.presenterUserId,
        "presenterName" : presenter.presenterName
      }
      this.agendaPresenterList.push(presenterJsonList)
      

    });
    this.notesEditBox.controls['agendaTitle'].setValue(this.agendaList.agendaTitle);
    this.notesEditBox.controls['agendaId'].setValue(this.agendaList.agendaId);
    this.notesEditBox.controls['agendaDuration'].setValue(this.agendaList.agendaDuration);
    this.notesEditBox.controls['agendaPresenterList'].setValue(this.agendaPresenterList);
    this.notesEditBox.controls['defaultNotes'].setValue(this.agendaList.defaultNotes);
    this.notesEditBox.controls['userId'].setValue(this.globals.userId);
    this.notesEditBox.controls['meetingId'].setValue(this.agendaList.meetingId);

  }

  updatePredefineNotes(){
    //
    this.meetingService.updateModernAgenda(this.notesEditBox.value,this.agendaList.agendaId).subscribe((res: { body: any; }) => {
      var resp = res.body;
      //
    });
    this.matDialogRef.close();

  }

}
